import * as yup from "yup";
import {RegisterUserRequest} from "../../../../lib/services/mainApi";

export const createValidationSchema: yup.ObjectSchema<RegisterUserRequest> = yup.object({
    username: yup.string().email().required(),
    password: yup.string().required().test('len', 'Must be at least 8 characters', val => {
        if(val)
            return val.length >= 8
        else return true

    }),
    locationTag: yup.string().required(),
    enableExtraOptions: yup.boolean().required(),
})

export const updateValidationSchema: yup.ObjectSchema<RegisterUserRequest> = yup.object({
    username: yup.string().email().required(),
    password: yup.string().optional().nullable().test('len', 'Must be at least 8 characters', val => {
        if(val)
            return val.length >= 8
        else return true

    }),
    locationTag: yup.string().required(),
    enableExtraOptions: yup.boolean().required(),
})
